import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

interface Company {
  name: string;
  companyEmail: string;
}

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  expiresIn: number | null;
  cognitoId: string | null;
  email: string | null;
  company: Company | null;
  userId: number | null;
  firstName: string | null;
  lastName: string | null;
  fullName: string | null;
  domain: string | null;
  organizationId: number | null;
  viewerName?: string | null;
  contactSignedUrl?: string | null;
  userSignedUrl?: string | null;
}

const stored = localStorage.getItem("authData");
const initialAuthData: AuthState = stored
  ? JSON.parse(stored)
  : {
      accessToken: null,
      refreshToken: null,
      expiresIn: null,
      cognitoId: null,
    userId: null,
      email: null,
      company: null,
      firstName: null,
      lastName: null,
      fullName: null,
      domain: null,
      organizationId: null,
    };

const authSlice = createSlice({
  name: "auth",
  initialState: initialAuthData,
  reducers: {
    setAuth: (state, action: PayloadAction<AuthState>) => {
      Object.assign(state, action.payload);
      localStorage.setItem("authData", JSON.stringify(action.payload));
    },
    clearAuth: () => {
      localStorage.removeItem("authData");
      return {
        accessToken: null,
        refreshToken: null,
        expiresIn: null,
        cognitoId: null,
        email: null,
        company: null,
        userId: null,
        firstName: null,
        lastName: null,
        fullName: null,
        domain: null,
        organizationId: null,
      };
    },
  },
});
export const selectAuth = (state: RootState) => state.auth;
export const selectIsLoggedIn = (state: RootState) => !!state.auth.accessToken;

export const { setAuth, clearAuth } = authSlice.actions;
export default authSlice.reducer;
